import { Dispatch, useContext } from 'react'
import { RewindDirection } from '../../enums/RewindDirection'
import { CutterContext } from '../../contexts/CutterContext'
import { InternalContext } from '../../contexts/InternalContext'
import { useHotkey } from '../../../hooks/useHotkey'
import { AppContext } from '../../../AppContext'

export function useChannelsRewindHotKeys(showIcon: Dispatch<RewindDirection>) {
  const { hotkeysEnabled } = useContext(AppContext)
  const { sampleRate } = useContext(CutterContext).audioBuffer
  const { audioPlayer } = useContext(InternalContext)

  useHotkey(
    (event) => event.key === 'ArrowLeft' || event.key === 'ArrowRight',
    (event) => {
      const backward = event.key === 'ArrowLeft'

      audioPlayer.rewind((position) => position + (backward ? -5 : 10) * sampleRate)

      showIcon(backward ? RewindDirection.Backward : RewindDirection.Forward)
    },
    hotkeysEnabled && audioPlayer.playback,
  )
}
